import { render, staticRenderFns } from "./claim.vue?vue&type=template&id=290f7d24&scoped=true&"
import script from "./claim.vue?vue&type=script&lang=js&"
export * from "./claim.vue?vue&type=script&lang=js&"
import style0 from "./claim.vue?vue&type=style&index=0&id=290f7d24&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../tmp/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290f7d24",
  null
  
)

export default component.exports